import { createRoot } from "react-dom/client";
import App from "./App";
import { installChunkReload } from "./lib/chunkReload";
import "./i18n/config";
import "./index.css";

// Exploración a todo color: Safari en iOS solo aplica :active (la foto en color
// mientras se toca una tarjeta) si hay algún escuchador de touchstart.
document.addEventListener("touchstart", () => {}, { passive: true });

installChunkReload();

// Sentry cuando la página ya está pintada (31-10-2026): eran 31 KB comprimidos
// delante del primer pintado en móvil. Los errores de antes se pierden; el
// ErrorBoundary también lo pide bajo demanda.
const startSentry = () => void import("./lib/sentry").then((m) => m.initSentry());
if ("requestIdleCallback" in window) window.requestIdleCallback(startSentry, { timeout: 4000 });
else setTimeout(startSentry, 2000);

// Contenido estático del prerender (scripts/prerender.mjs): <h1>, sinopsis,
// cines y horarios. Se saca de #root ANTES de montar, para que createRoot no lo
// borre, y se quita en cuanto la SPA pinta su propio <h1>: así la página nunca
// se queda sin título mientras cargan los datos (patrón de republico.app, donde
// Bing marcaba "H1 tag missing"). Con JS sigue oculto a la vista (html.js-on);
// si la SPA no pinta ningún <h1> (la cartelera), se queda: es el mismo
// contenido. Fuera de #root pasa de <main> a <div> para no tener dos <main>.
const prerendered = document.querySelector("#root > .prerender-seo");
const root = document.getElementById("root");
if (prerendered && root) {
  const staticMain = document.createElement("div");
  staticMain.className = prerendered.className;
  staticMain.setAttribute("style", prerendered.getAttribute("style") ?? "");
  staticMain.append(...prerendered.childNodes);
  prerendered.remove();
  root.after(staticMain);
  const spaHeading = () => document.querySelector('#root h1, [role="dialog"] h1');
  const observer = new MutationObserver(() => {
    if (spaHeading()) {
      staticMain.remove();
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

createRoot(document.getElementById("root")!).render(<App />);
